import React, { Component } from 'react';
import { connect } from 'react-redux';

import { changeUsername } from 'actions/settings';

import ChangeUsernameModalComponent from './ChangeUsernameModalComponent';

const INITIAL_STATE = {
  isComplete: false,
};

export class ChangeUsernameModalContainer extends Component {
  state = { ...INITIAL_STATE }

  handleRequestClose = () => {
    const { onRequestClose } = this.props;
    // Clean up before we close
    this.setState({ ...INITIAL_STATE });
    onRequestClose();
  }

  handleSubmit = async ({ username }, { setSubmitting, setErrors }) => {
    const { dispatch } = this.props;
    const { isSuccess, message } = await dispatch(changeUsername(username));
    setSubmitting(false);
    if (isSuccess) {
      return this.setState({ isComplete: true });
    }
    // Uh-oh, we have an error
    setErrors({ username: message });
  }

  render = () => {
    const { isOpen } = this.props;
    const { isComplete, successMessage } = this.state;
    return (
      <ChangeUsernameModalComponent
        isOpen={isOpen}
        isComplete={isComplete}
        onRequestClose={this.handleRequestClose}
        onSubmit={this.handleSubmit}
        successMessage={successMessage}
      />
    );
  }
}

export default connect()(ChangeUsernameModalContainer);